exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panel-loading{display:flex;height:100%;align-items:center;justify-content:center;font-size:2em;color:#b9b9ba;color:var(--text, #b9b9ba)\n}\n.panel-loading .loading-text svg{line-height:0;vertical-align:middle;color:#b9b9ba;color:var(--text, #b9b9ba)\n}", ""]);

// exports
